import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

import { auth } from "../../../utils/auth";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import { useLocation } from "react-router-dom";

const celda = { border: "1px solid #dee2e6", verticalAlign: "middle" };

/**
 * Pendiente del documento después del cheque: lo que falta por pagar de la compra
 * o por cobrar de la factura.
 */
const pendienteDe = (documento) => documento.porPagar ?? documento.porCobrar ?? 0;

const PrintCheques = () => {
    const [cheques, setCheques] = useState([]);
    const [listo, setListo] = useState(false);

    const user = auth.getUser();
    const sucursal = user.sucursales.filter(
        (suc) => suc.id === user.sucursalActual
    )[0];

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const getCheques = async () => {
        const response = await request(
            "cheques" + window.location.search + "&limit=1000000"
        );

        if (response.data) {
            setCheques(response.data);
            setListo(true);
        }
    };

    useEffect(() => {
        getCheques()
    }, []);

    // Espera a que el estado con los datos ya esté reflejado en el DOM
    // antes de abrir el diálogo de impresión.
    useEffect(() => {
        if (listo) {
            window.print();
        }
    }, [listo]);

    // Cada fila es un cheque físico, así que los totales ya no cuentan dos veces
    // un cheque que pagó varias facturas.
    const sumar = (filtro) => cheques.filter(filtro).reduce((sum, cheque) => sum + cheque.monto, 0);
    const validos = sumar((c) => c.status === 'válido');
    const rechazados = sumar((c) => c.status === 'rechazado');
    const total = sumar(() => true);

    return (
        <div>
            <div className='row'>
                <h2 className='col-md-12 text-center m-b-5'>
                    Cheques
                </h2>
                <div className='col-md-12 text-center'>
                    {sucursal.nombre} - {sucursal.direccion} •{" "}

                    {queryParams.get("desde") && queryParams.get("hasta") ? (
                        <span>
                            {queryParams.get("desde")
                                ? `${dayjs(queryParams.get("desde")).format(
                                        "DD/MM/YYYY"
                                    )} - `
                                : ""}{" "}
                            {dayjs(queryParams.get("hasta")).format("DD/MM/YYYY")}
                        </span>
                    ) : (
                        <span>{dayjs().format("DD/MM/YYYY")}</span>
                    )}
                </div>
                <div className='col-md-12 text-right p-b-10'>
                    <div className='float-left'>
                        TOTAL CHEQUES: {cheques.length}
                    </div>

                    <div className='float-right'>
                        <h3 className="m-0">TOTAL VÁLIDOS: {formatCurrency(validos)}</h3>
                    </div>
                </div>

                <div className='col-md-12 text-right p-b-10'>
                    <div className='float-right'>
                        <h3 className="m-0">TOTAL RECHAZADOS: {formatCurrency(rechazados)}</h3>
                    </div>
                </div>
                <div className='col-md-12 text-right p-b-10'>
                    <div className='float-right'>
                        <h3>TOTAL: {formatCurrency(total)}</h3>
                    </div>
                </div>
            </div>
            <table className='table m-b-40'>
                <thead>
                    <tr>
                        <th></th>
                        <th>Fecha</th>
                        <th>No. Cheque</th>
                        <th>Concepto</th>
                        <th>Monto</th>
                        <th>Cuenta</th>
                        <th>Contacto</th>
                        <th>Balance Pendiente</th>
                        <th>Estatus</th>
                    </tr>
                </thead>
                <tbody>
                    {cheques.map((cheque, index) => {
                        const documentos = cheque.documentos || [];
                        const fecha = dayjs(cheque.fecha).format('DD-MM-YYYY');

                        if (documentos.length <= 1) {
                            const documento = documentos[0];

                            return (
                                <tr key={cheque.id}>
                                    <td>{index + 1}</td>
                                    <td style={{textWrap: "nowrap"}}>{fecha}</td>
                                    <td>{cheque.numero}</td>
                                    <td>{cheque.concepto}</td>
                                    <td>{formatCurrency(cheque.monto)}</td>
                                    <td>{cheque.cuenta?.nombre}</td>
                                    <td>{cheque.contacto?.nombre}</td>
                                    <td>{documento ? formatCurrency(pendienteDe(documento)) : ""}</td>
                                    <td style={{textTransform: 'uppercase'}}>{cheque.status}</td>
                                </tr>
                            );
                        }

                        const filas = documentos.length;

                        return (
                            <React.Fragment key={cheque.id}>
                                <tr>
                                    <td colSpan={9} className="text-center">
                                        <h3>
                                            {`TRANSACCIONES MÚLTIPLES: CHEQUE ${cheque.numero}, VALOR DEL CHEQUE: ${formatCurrency(cheque.monto)}`}
                                        </h3>
                                    </td>
                                </tr>

                                {documentos.map((documento, i) => (
                                    <tr key={documento.id}>
                                        {i === 0 && <td rowSpan={filas} style={{...celda, borderLeft: 0}}>{index + 1}</td>}
                                        {i === 0 && <td rowSpan={filas} style={{...celda, textWrap: "nowrap"}}>{fecha}</td>}
                                        {i === 0 && <td rowSpan={filas} style={celda}>{cheque.numero}</td>}
                                        <td style={celda}>{documento.concepto}</td>
                                        <td style={celda}>{formatCurrency(documento.monto)}</td>
                                        {i === 0 && <td rowSpan={filas} style={celda}>{cheque.cuenta?.nombre}</td>}
                                        {i === 0 && <td rowSpan={filas} style={celda}>{cheque.contacto?.nombre}</td>}
                                        <td style={celda}>{formatCurrency(pendienteDe(documento))}</td>
                                        {i === 0 && <td rowSpan={filas} style={{...celda, textTransform: 'uppercase', borderRight: 0}}>{cheque.status}</td>}
                                    </tr>
                                ))}

                                <tr><td colSpan={9} className="text-center">&nbsp;</td></tr>
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
            <div className='row'>
                <div className='col-md-12 text-right p-b-10'>
                    <div className='float-left'>
                        TOTAL CHEQUES: {cheques.length}
                    </div>

                    <div className='float-right'>
                        <h3>TOTAL: {formatCurrency(total)}</h3>
                    </div>
                </div>
            </div>

            <style type="text/css" media="print">
                @page {"{ size: landscape; }"}
            </style>
        </div>
    );
};

export default PrintCheques;
